<script>
  import SpeakersWithEventDescription from "../../Component/SpeakersWithEventDescription.svelte";
  import { Button } from "../../../Components";
  import { Loading } from "../../../Components/Icons";
  import { doLoading } from "../../Api/congress_stores.js";
  import { createEventDispatcher } from "svelte";
  import clsx from "clsx";

  export let item;
  export let anmeldestop;
  // export let startTime;
  // export let endTime;
  // export let startDateFormated;

  const dispatch = createEventDispatcher();
  const actionId = item.veranstaltungId;
  const notRegistred = item.tnHasKongress != 1 ? "Sie sind nicht für diesen Kongress angemeldet." : false;

  let showLoading = false;

  let itemStartDateFormated;

  if (item.startDate) {
    item.startDateObj = new Date();
    item.startDateObj.setTime(Date.parse(item.startDate));
    itemStartDateFormated = item.startDateObj.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
  }

  doLoading.subscribe((value) => {
    showLoading = value;
  });

  let button = {
    info: null,
    infoStrong: null,
    text: null,
    action: null,
  };

  function processBookingAction(actionType) {
    doLoading.update(() => true);

    // Check if the user is registered for the congress
    if (actionType.startsWith("booking") && notRegistred) {
      alert(notRegistred);
      doLoading.update(() => false);
      return;
    }

    dispatch("booking", { actionType, actionId });
  }

  function setupButton(item) {
    if (item.tnHasSeat == 1) {
      button = {
        info: "Ein Sitzplatz ist für Sie reserviert.",
        infoStrong: "text-green-700",
        text: "Abmelden",
        action: "unbooking",
      };
      return;
    }

    if (item.tnTimeBlocked == 1) {
      button = {
        info: "Sie sind schon zu einer anderen Veranstaltung zum selben Zeitpunkt angemeldet!",
        infoStrong: "text-red-700",
      };
      return;
    }

    if (item.tnSeatAvailable == 1) {
      button = {
        text: "Sitzplatz reservieren",
        action: "booking",
      };
      return;
    }

    if (item.tnHasWaitinglist == 1) {
      button = {
        info: "Sie sind aktuell auf der Warteliste. Sollte ein reservierter Sitzplatz frei werden, werden Sie umgehend via Mail darüber informiert.",
        text: "Warteliste abmelden",
        action: "unbookingWaitinglist",
      };
      return;
    }

    button = {
      info: "Das Kontingent der Onlinesitzplatzbuchung ist bereits erschöpft. Nutzen Sie bitte die Möglichkeit der Warteliste. Sollte ein reservierter Sitzplatz frei werden, werden Sie umgehend via Mail darüber informiert.",
      text: "Warteliste",
      action: "bookingWaitinglist",
    };
  }

  $: setupButton(item);
</script>

<SpeakersWithEventDescription
  id="v_{item.veranstaltungId}"
  {item}
  firstPersonIsModerator={item.referentCount == 6 ? [9, 10, 12].includes(item.typ) : [9, 10].includes(item.typ)}
  moderatorSalutatory={item.moderatorSalutatory}
>
  <svelte:fragment slot="headline">
    <h2 class="mb-1 hidden border-l-[6px] border-theme-signal pl-2 text-3xl italic leading-7 sm:block">
      <small class="mb-2 block text-lg font-medium not-italic leading-4 text-im-brown-600">
        {item.referent1imageTitle}
      </small>
      {item.typName} <strong class="text-theme-minor-600">{item.eventTitle}</strong>
    </h2>
  </svelte:fragment>

  <svelte:fragment slot="date">
    {itemStartDateFormated}
    {item.startTime} - {item.endTime}{#if item.location}, Saal {item.location}{/if}
  </svelte:fragment>
  <svelte:fragment slot="actions">
    {#if !anmeldestop}
      {#if button.info}
        {#if button.infoStrong}
          <strong class={clsx("my-2 block", typeof button.infoStrong == "string" && button.infoStrong)}>{button.info}</strong>
        {:else}
          <span class="my-2 block">{button.info}</span>
        {/if}
      {/if}

      {#if button.action && button.text}
        <Button
          minor
          disabled={showLoading || notRegistred}
          tooltip={notRegistred}
          on:click={() => {
            if (notRegistred) {
              return;
            }
            processBookingAction(button.action);
          }}
        >
          {button.text}
          <Loading {showLoading} />
        </Button>
      {/if}
    {/if}
  </svelte:fragment>
</SpeakersWithEventDescription>
